module.exports = __webpack_public_path__ + "img/btn_games_.04581a12.png";